import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import styled from '../../styles/styled';
import theme from '../../styles/theme';
export const IconButtonRow = ({ activeItemIndex, children, }) => {
    return (_jsxs(IconButtonRowWrapper, { children: [_jsx(AnimatedActiveIconBackground, { activeItemIndex: activeItemIndex }), children] }));
};
const IconButtonRowWrapper = styled.div(({ activeItemIndex }) => ({
    display: 'inline-flex',
    background: !activeItemIndex ? 'rgba(255, 255, 255, 0.5)' : theme.colors.white,
    padding: '6px',
    borderRadius: '26px',
    '> :not(:first-of-type)': {
        marginLeft: theme.spacing.m,
    },
    '> *': {
        zIndex: 2,
    },
}));
const AnimatedActiveIconBackground = styled.span(({ activeItemIndex }) => ({
    position: 'absolute',
    transform: `translateX(${activeItemIndex * 56}px)`,
    transition: `transform 200ms cubic-bezier(0.25,-0.20, 0.40, 1.25)`,
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: `${activeItemIndex === undefined ? theme.colors.transparent : theme.colors.azure}`,
    zIndex: 1,
}));
//# sourceMappingURL=icon_button_row.js.map